import React from 'react';
import { Link } from 'react-router-dom';
import Reveal from '../../../shared/Reveal/Reveal';
import './Start.css';

const Start = ({ title, text, cta }) => {
  if (!title) {
    return null;
  }

  return (
    <section className="market-start">
      <div className="market-start__inner">
        <Reveal className="market-start__content">
          <h2 className="market-start__title">{title}</h2>
          {text ? <p className="market-start__text">{text}</p> : null}
          {cta?.text && cta?.url ? (
            <Link to={cta.url} className="market-start__cta luxury-btn">
              {cta.text}
            </Link>
          ) : null}
        </Reveal>
      </div>
    </section>
  );
};

export default Start;
